export const FETCH_SEGMAP_LIST = 'FETCH_SEGMAP_LIST'
export const STORE_FETCHED_SEGMAP_LIST = 'STORE_FETCHED_SEGMAP_LIST'
export const STORE_FETCHED_COMPANY_LIST = 'STORE_FETCHED_COMPANY_LIST'
export const FETCH_SEGMAP_LIST_FAILURE = 'FETCH_SEGMAP_LIST_FAILURE'

export const FETCH_COST_CATEGORY = 'FETCH_COST_CATEGORY'
export const STORE_FETCHED_COST_CATEGORY = 'STORE_FETCHED_COST_CATEGORY'
export const FETCH_COST_CATEGORY_FAILURE = 'FETCH_COST_CATEGORY_FAILURE'

export const FETCH_COST_CENTER = 'FETCH_COST_CENTER'
export const STORE_FETCHED_COST_CENTER = 'STORE_FETCHED_COST_CENTER'
export const FETCH_COST_CENTER_FAILURE = 'FETCH_COST_CENTER_FAILURE'

export const SET_ALERT_MODAL_STATE = "SET_ALERT_MODAL_STATE";

